(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/carousel/assets/javascripts/react/carousel.js') >= 0) return;  svs.modules.push('/components/tb-ui/carousel/assets/javascripts/react/carousel.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  Children,
  isValidElement,
  useEffect,
  useMemo,
  useRef,
  useState
} = React;
const {
  CarouselNavigation
} = svs.components.tbUi.carousel;
const {
  useDrag
} = svs.components.tbUi.carousel.hooks;
const {
  calculateScrollbarWidth
} = svs.components.tbUi.carousel.utils;
const DRAG_THRESHOLD = 50;
const Carousel = _ref => {
  let {
    branding,
    children,
    className,
    options
  } = _ref;
  const {
    useMediaQuery,
    breakpoints,
    BREAKPOINT_AM
  } = svs.components.tbUtils.useMediaQuery;
  const defaultOptions = {
    isMobile: false,
    selectedIndex: 0,
    theme: 'brand'
  };
  const shouldReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)") === true || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
  const {
    isMobile,
    selectedIndex,
    theme
  } = _objectSpread(_objectSpread({}, defaultOptions), options);
  const isMobileQuery = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const mobileView = isMobile || isMobileQuery;

  const [index, setIndex] = useState(() => selectedIndex);
  const ref = useRef(null);
  const navRef = useRef(null);
  const cntRef = useRef(null);
  const {
enable,
    release,
    registerCallbacks
  } = useDrag(ref);
  const mappedChildren = useMemo(() => Children.map(Array.isArray(children) ? children : [children], (child, childIndex) => {
    if (isValidElement(child)) {
      const {
        title
      } = child.props;
      const clone = React.cloneElement(child, {
        isSelected: index === childIndex
      });
      return React.createElement("div", {
        "aria-hidden": childIndex !== index,
        "aria-label": title,
        "aria-roledescription": "karusellsida ".concat(index + 1),
        className: ['ui-carousel-item', childIndex === selectedIndex ? 'ui-carousel-item-selected' : ''].filter(Boolean).join(' '),
        role: "group"
      }, React.createElement("div", {
        className: "ui-carousel-item-inner"
      }, clone));
    }
    return null;
  }), [children, index, selectedIndex]);
  const onMove = _ref2 => {
    let {
      x
    } = _ref2;
    if (Math.abs(x) > DRAG_THRESHOLD) {
      release();
      setIndex(i => {
        const newIndex = x > 0 ? Math.max(0, i - 1) : Math.min(children.length - 1, i + 1);
        return newIndex;
      });
    }
  };
  registerCallbacks({
    onMove
  });
  enable();

  useEffect(() => {
    const container = ref === null || ref === void 0 ? void 0 : ref.current;
    const keyNavigtion = e => {
      switch (e.code) {
        case 'ArrowLeft':
          setIndex(currentIndex => Math.max(0, currentIndex - 1));
          break;
        case 'ArrowRight':
          setIndex(currentIndex => Math.min(children.length - 1, currentIndex + 1));
          break;
        default:
      }
    };
    container === null || container === void 0 || container.addEventListener('keyup', keyNavigtion);
    return () => {
      container === null || container === void 0 || container.removeEventListener('keyup', keyNavigtion);
    };
  }, [children]);
  useEffect(() => {
    const container = cntRef.current;
    if (ref.current && container) {
      ref.current.style.setProperty('--scrollbar-width', "".concat(calculateScrollbarWidth(), "px"));
      const options = {
        root: ref.current,
        rootMargin: '0px',
        threshold: 1.0
      };
      const intersectionCallback = entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            navRef === null || navRef === void 0 || navRef.current.classList.remove('ui-carousel-nav-sticky');
          } else {
            navRef === null || navRef === void 0 || navRef.current.classList.add('ui-carousel-nav-sticky');
          }
        });
      };
      const observer = new IntersectionObserver(intersectionCallback, options);
      observer.observe(container);
      return () => observer.unobserve(container);
    }
  }, []);
  return (children === null || children === void 0 ? void 0 : children.length) > 0 && React.createElement("div", {
    className: ['ui-carousel', branding ? "ui-carousel-".concat(branding) : '', shouldReduceMotion ? 'ui-carousel-reduced-motion' : '', theme ? "ui-carousel-".concat(theme) : '', mobileView ? 'ui-carousel-mobile' : '', className].filter(Boolean).join(' '),
    "data-testid": "ui-carousel",
    ref: ref
  }, React.createElement("div", {
    className: "ui-carousel-scroll-area"
  }, React.createElement("div", {
    "aria-label": "",
    "aria-roledescription": "karusell",
    className: "ui-carousel-container",
    ref: cntRef
  }, children.length > 1 && React.createElement(CarouselNavigation, {
    numberOfPages: children.length,
    onChange: i => setIndex(i),
    ref: navRef,
    selectedIndex: index
  }), React.createElement("div", {
    "aria-live": "polite",
    className: "ui-carousel-items",
    "data-testid": "ui-carousel-items",
    style: {
      transform: "translateX(".concat(index * 100 * -1, "%)")
    }
  }, mappedChildren), children.length > 1 && React.createElement("div", {
    "aria-atomic": "true",
    "aria-live": "polite",
    className: "visuallyhidden",
    "data-testid": "ui-carousel-live"
  }, "Sida ".concat(index + 1, " av ").concat(children.length)))));
};
Carousel.defaultProps = {
  children: []
};
setGlobal('svs.components.tbUi.carousel.Carousel', Carousel);

 })(window);